/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/resource-less.html";

const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);

require("Styles/components/popup/resource-less.scss");

class ResourceLessView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.event = options.event;
        this.type = options.type;
        this.roundData = options.roundData || {};

        let container = options.html.find(".resource-button-container");

        options.html.find(".popup-subtitle").attr("data-localize", "resource-less." + this.type + ".title");
        options.html.find(".popup-message").attr("data-localize", "resource-less." + this.type + ".description");

        this.renderResourceButtons(container);
    }

    getRemovedResource()
    {
        let buttons = $(".resource-button-container").find(".selected");

        if (buttons.length > 0)
        {
            return $(buttons[0]).data("resource");
        }

        return null;
    }

    renderResourceButtons(container)
    {
        container.empty();

        let resources = [];

        if (this.type === "microchip")
        {
            resources = [ "resource_red", "resource_yellow", "resource_purple" ];
        }
        else if (this.type === "phone")
        {
            resources = [ "resource_yellow" ];
        }
        else if (this.type === "bike")
        {
            resources = [ "resource_red", "resource_purple" ];
        }

        for (let resource of resources)
        {
            let button = $("<div class='resource-button'>");
            let img = "<img src='" + resourceIcons("./" + resource + ".svg") + "' />";

            button.append(img);
            button.data("resource", resource);
            button.attr("data-resource", resource);

            button.off("click").on("click", function()
            {
                if (button.hasClass("disabled") || button.hasClass("not-selectable"))
                {
                    return;
                }

                if (button.hasClass("selected"))
                {
                    button.removeClass("selected");
                }
                else
                {
                    button.addClass("selected");
                }

                let totalSelected = container.find(".selected").length;

                if (totalSelected === 1)
                {
                    container.find(".resource-button").not(".selected").addClass("disabled");
                }
                else
                {
                    container.find(".resource-button").removeClass("disabled");
                }
            });

            container.append(button);
        }

        let forcedButton = undefined;

        if (resources.length === 1)
        {
            forcedButton = container.find(".resource-button")[0];
        }
        else if (this.roundData.resourceRed === 0 && resources.includes("resource_red"))
        {
            forcedButton = container.find(".resource-button[data-resource=resource_red]")[0]
        }
        else if (this.roundData.resourceYellow === 0 && resources.includes("resource_yellow"))
        {
            forcedButton = container.find(".resource-button[data-resource=resource_yellow]")[0]

        }
        else if (this.roundData.resourcePurple === 0 && resources.includes("resource_purple"))
        {
            forcedButton = container.find(".resource-button[data-resource=resource_purple]")[0]
        }

        if (forcedButton)
        {
            forcedButton.click();
            $(container).find(".resource-button").off("click");
        }
    }
}

module.exports = ResourceLessView;



// WEBPACK FOOTER //
// ./app/js/components/popup/resource-less.js